import getRedirectUrl from "../../../foundation/utils/get-redirect-url";
import checkAuthError from "../../../foundation/utils/checkAuthError";
import PreactDOMComponent from "../../../foundation/utils/preact-dom-component";
import LoginSSOPage from "../../containers/LoginSignup/pages/LoginSSOPage/LoginSSOPage";

import "../electronApp/windowsAppUpdates";

const LoginSSOPageComponent = new PreactDOMComponent(LoginSSOPage, document.body);

const loginParams = {};
function processUrlParams() {
    if (location.search) {
        location.search.substr(1).split("&").forEach(param => {
            const [key, value] = param.split("=");
            loginParams[decodeURIComponent(key)] = decodeURIComponent(value);
        });

        history.replaceState({}, "Zeplin - Login", location.pathname);
    }

    if (loginParams.redirect) {
        sessionStorage.setItem("redirectTo", getRedirectUrl(loginParams.redirect, "/"));
    }
}

function render() {
    LoginSSOPageComponent.render({
        loginParams
    });
}

processUrlParams();
render();
checkAuthError();
